import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: theme.spacing(6),
    },
    title: {
        "&.MuiTypography-root": {
            fontWeight: 600,
            fontSize: "20px",
            padding: "20px 0",
            color: theme.palette.text.primary,
        },
    },
    formContainer: {
        marginTop: theme.spacing(2),
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
        marginTop: theme.spacing(5),
        paddingTop: theme.spacing(2),
    },
    testButton: {
        minWidth: 140,
        color: theme.palette.text.primary + " !important",
        borderColor: theme.palette.text.primary + " !important",
        backgroundColor: "FF5FAFF !important",
    },
    saveButton: {
        minWidth: 140,
        color: theme.palette.text.primary + " !important",
        borderColor: theme.palette.text.primary + " !important",
        backgroundColor: "FF5FAFF !important",
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            color: theme.palette.corporateBO.checkbox,
            "&.Mui-checked": {
                color: theme.palette.info.main,
            },
            "&.Mui-disabled": {
                color: theme.palette.corporateBO.checkbox,
                "&.Mui-checked": {
                    color: theme.palette.info.main,
                },
            },
        },
    },
}));
